export const SKIP_SECONDS = 10;

export const skippedTime = (currentTime: number, duration: number, seconds: number): number => {
  const target = currentTime + seconds;
  if (target < 0) return 0;
  if (Number.isFinite(duration) && duration > 0) return Math.min(target, duration);
  return target;
};
